import { FlightCard, SearchResponse } from '@/src/types/flight'
import { isEmpty } from '../../generalUtils'
import { getSplitId } from '../searchUtils/getSplitId'
import { constructSplrt } from './constructSplRT'

export const modifyPricesAndSortOnwardLeg = (flightResultResponseData: SearchResponse) => {
    if (flightResultResponseData?.cards?.length < 2) {
        return flightResultResponseData
    }
    // //make copy of the flightResultResponseData to avoid mutating the original data
    // flightResultResponseData = JSON.parse(JSON.stringify(flightResultResponseData))
    // if (!flightResultResponseData || !flightResultResponseData.cards) {
    //     return flightResultResponseData
    // }

    const { cards = [], sortData } = flightResultResponseData || {}
    const cheapestReturnCardId = sortData?.price_up[1]?.[0] || ''
    const cheapestReturnCardIndex = Number(getSplitId(cheapestReturnCardId)?.[1]) || 0
    const cheapestReturnCardPrice = cards[1]?.at(cheapestReturnCardIndex)?.priceBreakup?.pr || 0
    const cheapestReturnCardPriceWODiscount =
        (cards[1]?.at(cheapestReturnCardIndex)?.priceBreakup?.pr || 0) +
        (cards[1]?.at(cheapestReturnCardIndex)?.priceBreakup?.ds || 0)
    if (Array.isArray(cards[0])) {
        cards[0].forEach((onwardCard, index) => {
            let cheapestPriceForCard = onwardCard.priceBreakup.pr + cheapestReturnCardPrice
            let cheapestPriceForCardWODiscount =
                onwardCard.priceBreakup.pr + onwardCard.priceBreakup.ds + cheapestReturnCardPriceWODiscount
            let cheapestPriceForSpecialRT = cheapestPriceForCard
            let cheapestPriceForSpecialRTWODiscount = cheapestPriceForCardWODiscount
            cards[1].forEach((returnCard, returnIndex) => {
                const {
                    isSpecialRT: isOnwawrdSpecialRT,
                    splrtFare: onwardSplrtFare,
                    splrtFareWODiscount: onwardSplrtFareWODiscount
                } = constructSplrt(onwardCard, returnCard.splRtFn) || {}
                const {
                    isSpecialRT: isReturnSpecialRT,
                    splrtFare: returnSplrtFare,
                    splrtFareWODiscount: returnSplrtFareWODiscount
                } = constructSplrt(returnCard, onwardCard.splRtFn) || {}
                const specialRTPrice = (onwardSplrtFare || 0) + (returnSplrtFare || 0)
                const specialRTPriceWODiscount = (onwardSplrtFareWODiscount || 0) + (returnSplrtFareWODiscount || 0)
                if (
                    isOnwawrdSpecialRT &&
                    isReturnSpecialRT &&
                    specialRTPrice < cheapestPriceForSpecialRT &&
                    specialRTPrice < cheapestPriceForCard
                ) {
                    cheapestPriceForSpecialRT = specialRTPrice
                    cheapestPriceForSpecialRTWODiscount = specialRTPriceWODiscount
                }
            })
            if (cheapestPriceForSpecialRT < cheapestPriceForCard) {
                onwardCard.priceBreakup.multiAirlinePrice = cheapestPriceForSpecialRT
                onwardCard.priceBreakup.multiAirlinePriceWoDiscount =
                    cheapestPriceForSpecialRTWODiscount > cheapestPriceForSpecialRT
                        ? cheapestPriceForSpecialRTWODiscount
                        : undefined

                const couponDetail = onwardCard?.priceBreakup?.fare?.coupon_detail

                if (couponDetail?.discountAmount) {
                    couponDetail.discountedPrice = cheapestPriceForSpecialRT - couponDetail.discountAmount
                }
            } else {
                onwardCard.priceBreakup.multiAirlinePrice = cheapestPriceForCard
                onwardCard.priceBreakup.multiAirlinePriceWoDiscount =
                    cheapestPriceForCardWODiscount > cheapestPriceForCard ? cheapestPriceForCardWODiscount : undefined

                const couponDetail = onwardCard?.priceBreakup?.fare?.coupon_detail

                if (couponDetail?.discountAmount) {
                    couponDetail.discountedPrice = cheapestPriceForCard - couponDetail.discountAmount
                }
            }
        })

        sortData.price_up[0] = cards[0]
            .toSorted((a, b) => {
                return (a.priceBreakup.multiAirlinePrice || 0) - (b.priceBreakup.multiAirlinePrice || 0)
            })
            .map(card => {
                return card.id
            })
    }
    return flightResultResponseData
}

export const modifyPricesAndSortOfReturnLeg = (
    flightResultResponseData: SearchResponse,
    selectedOnwardCard: FlightCard
) => {
    if (!isEmpty(selectedOnwardCard) && Array.isArray(flightResultResponseData.cards[1])) {
        flightResultResponseData.cards[1].forEach(returnCard => {
            const { isSpecialRT: isOnwawrdSpecialRT, splrtFare: onwardSplrtFare } =
                constructSplrt(selectedOnwardCard, returnCard.splRtFn) || {}
            const { isSpecialRT: isReturnSpecialRT, splrtFare: returnSplrtFare } =
                constructSplrt(returnCard, selectedOnwardCard.splRtFn) || {}
            const normalPrice = returnCard.priceBreakup.pr + selectedOnwardCard.priceBreakup.pr
            let totalPrice = 0
            if (isOnwawrdSpecialRT && isReturnSpecialRT) {
                const specialRTPrice = (onwardSplrtFare || 0) + (returnSplrtFare || 0)
                totalPrice = normalPrice < specialRTPrice ? normalPrice : specialRTPrice
            } else {
                totalPrice = normalPrice
            }
            returnCard.priceBreakup.multiAirlinePrice =
                totalPrice - (selectedOnwardCard.priceBreakup.multiAirlinePrice || 0)
        })

        flightResultResponseData.sortData.price_up[1] = flightResultResponseData.cards[1]
            .toSorted((a, b) => {
                return (a.priceBreakup.multiAirlinePrice || 0) - (b.priceBreakup.multiAirlinePrice || 0)
            })
            .map(card => {
                return card.id
            })
    }

    return flightResultResponseData
}

// export const getModifySortedReturnLegCardIds = (cards: any[], selectedJourneyLeg, isIntlRT) => {
//     if (isIntlRT && selectedJourneyLeg === 1 && Array.isArray(cards)) {
//         return cards
//             .toSorted((a, b) => a.priceBreakup.multiAirlinePrice - b.priceBreakup.multiAirlinePrice)
//             .map(card => card.id)
//     }

//     return null
// }
